import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Landing() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen relative overflow-hidden bg-[#050505]">
      <div className="absolute inset-0 opacity-40"
        style={{ backgroundImage: "url(https://images.pexels.com/photos/5192289/pexels-photo-5192289.jpeg)", backgroundSize: "cover", backgroundPosition: "center" }} />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/80 to-black" />
      <div className="absolute -top-40 -left-40 w-[480px] h-[480px] rounded-full bg-[#E60000]/15 blur-[120px]" />
      <div className="absolute bottom-0 right-0 w-[420px] h-[420px] rounded-full bg-[#E60000]/10 blur-[140px]" />

      <div className="relative max-w-5xl mx-auto px-6 pt-10 pb-24">
        <header className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="w-2.5 h-2.5 rounded-full bg-[#E60000] shadow-[0_0_12px_rgba(230,0,0,0.8)] animate-pulse" />
            <span className="font-display text-xl tracking-tighter">BlinkLink</span>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/login" data-testid="link-login" className="text-sm text-zinc-300 hover:text-white">{t("auth.signInTitle")}</Link>
          </div>
        </header>

        <section className="mt-24 md:mt-40 max-w-2xl mx-auto text-center">
          <p className="font-mono-accent text-[#E60000] mb-6" data-testid="hero-overline">{t("landing.overline")}</p>
          <h1 className="font-display text-5xl md:text-7xl leading-[0.95] tracking-tighter">
            {t("landing.heroLine1")}<br/>
            {t("landing.heroLine2")}<br/>
            <span className="italic font-light">{t("landing.heroLine3")}</span>
          </h1>
          <p className="mt-6 text-zinc-400 text-lg max-w-xl mx-auto leading-relaxed">
            {t("landing.heroBody")}
          </p>
          <div className="mt-10 flex justify-center">
            <Link to="/register" data-testid="hero-cta-register" className="px-8 py-4 rounded-full bg-[#E60000] hover:bg-[#FF1A1A] hover:shadow-[0_0_30px_rgba(230,0,0,0.5)] transition font-semibold">
              {t("auth.signUpLink")}
            </Link>
          </div>
          <div className="mt-16 grid grid-cols-3 gap-6 text-center max-w-md mx-auto">
            <div><div className="font-display text-3xl">3s</div><div className="font-mono-accent text-zinc-500 mt-1">{t("landing.statScan")}</div></div>
            <div><div className="font-display text-3xl">12h</div><div className="font-mono-accent text-zinc-500 mt-1">{t("landing.statChatLife")}</div></div>
            <div><div className="font-display text-3xl">25</div><div className="font-mono-accent text-zinc-500 mt-1">{t("landing.statVaultCap")}</div></div>
          </div>
        </section>
      </div>
    </div>
  );
}
